import React from 'react'

import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import {
  AccommodationItem,
  FlightItem,
  LETripItem,
} from 'tripPlanner/types/tripItem'
import { getOfferPagePrefilledStateParams } from 'tripPlanner/utils'
import { buildStandaloneFlightSearchURL } from 'tripPlanner/utils/bookmark/restoreCart'

interface Props {
  item: Extract<LETripItem, FlightItem | AccommodationItem>
  restoreCartUrl: string
}

function BookHotelFlight(props: Props) {
  const { item, restoreCartUrl } = props

  const { closeModal, goBack } = useModalCallbacks()

  let unbundledText: string
  let unbundledURL: string

  if (item.type === 'ACCOMMODATION') {
    const { searchParams, hash } = getOfferPagePrefilledStateParams(item, {
      scrollToOptions: true,
    })
    const queryString = searchParams.toString()
    const URLSuffix = queryString ? `?${queryString}` : ''

    unbundledText = 'No, book hotel only'
    unbundledURL = `/offer/hotel/${item.code}${URLSuffix}${hash}`
  } else {
    const data = structuredClone(item.savedItemData)
    delete data.hotelBundle

    unbundledText = 'No, book flights only'
    unbundledURL = buildStandaloneFlightSearchURL(data)
  }

  return (
    <>
      <ModalHeader
        title="Book hotel and flights package?"
        onBackButtonClick={goBack}
        onCloseButtonClick={closeModal}
      />
      <ModalBody>
        <ModalContent>
          <BodyText variant="large" as="p">
            You've added this order as a hotel and flights package.
          </BodyText>
          <BodyText variant="large" as="p">
            Do you want to book these items together?
          </BodyText>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Yes, book hotel and flights',
          to: restoreCartUrl,
        }}
        secondaryActionProps={{
          children: unbundledText,
          to: unbundledURL,
        }}
      />
    </>
  )
}

export default BookHotelFlight
